var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9213 7.5L20.5787 7.5C15.1689 7.5 12.4641 7.5 10.9788 9.27221C9.49355 11.0444 9.92425 13.758 10.7857 19.185L14.2224 40.8376C14.9647 45.514 16.04 46.9153 20.4545 48.6407L27.6891 51.4682C29.4491 52.1561 30.3291 52.5 31.25 52.5C32.1709 52.5 33.0509 52.1561 34.8109 51.4682L42.0455 48.6407C46.46 46.9153 47.5353 45.514 48.2776 40.8376L51.7143 19.185C52.5758 13.758 53.0065 11.0444 51.5212 9.27221C50.0359 7.5 47.3311 7.5 41.9213 7.5Z",
    stroke: "#25282B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 20L26.3173 20C24.0472 20 23.5898 20.4725 23.7936 22.7319L24.246 27.7495C24.4179 29.655 24.854 30.0351 26.7698 30.0351L34.6578 30.0351C36.9701 30.0351 37.4298 30.519 37.1766 32.8161L36.7534 36.6561C36.5831 38.2007 36.5348 38.2603 35.0489 38.7596L31.9629 39.7966C31.156 40.0678 31.1412 40.0678 30.3343 39.7966L26.9004 38.6427C25.9767 38.3323 25.667 37.9545 25.5018 37.0293",
    stroke: "#25282B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html-5.52d82dc62a6d3aece7ac20d09ea6787c.svg";
export { ForwardRef as ReactComponent };